import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    display: 'flex',
    flex: 1,
  },
  cardActionAreaWrapper: {
    display: 'block',
    position: 'relative',
  },
  labelImageWrapper: {
    position: 'absolute',
    left: theme.spacing(0),
    right: theme.spacing(0),
    bottom: theme.spacing(0),
    top: theme.spacing(0),
    padding: theme.spacing(1),
  },
  cardMediaWrapper: {
    width: '100%',
    height: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  inputInvisible: {
    display: 'block',
    visibility: 'hidden',
    width: theme.spacing(0),
    height: theme.spacing(0),
    outline: 'none',
    marginTop: theme.spacing(1),
  },
  errorTitle: {
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
    textAlign: 'center',
    fontSize: theme.typography.fontSize,
  },
}));

export default useStyles;
